import { downloadMeshes } from 'webgl-obj-loader'
import fragSource from './obj.fs'
import vertexSource from './obj.vs'
import { vec3, mat4 } from 'gl-matrix'
import { GUI } from 'dat.gui'

(() => {
  const {
    WeProject,
    WeProgram,
    WeShader,
    WeShaderData,
    WeShaderBuffer,
    Tool
  } = WebGLEngine
  const project = new WeProject('demo')
  const baseUrl = (location.origin.includes('location') || location.origin.includes('127.0.0.1')) ? location.origin : `${location.protocol}//xiexuefeng.cc/app/we`
  project.setSize(window.innerWidth, window.innerHeight)
  project.active()
  const ctx = project.getContext()
  const program = new WeProgram()
  const frag = new WeShader(fragSource, 'fragment')
  const vertex = new WeShader(vertexSource, 'vertex')
  program.addShader([vertex, frag])
  program.link()
  program.use()
  const p = mat4.create()
  mat4.perspective(p, 45 / 180 * Math.PI, window.innerWidth / window.innerHeight, 1, 1000)
  const v = mat4.create()
  const eye = vec3.fromValues(0, 100, 200)
  const look = vec3.fromValues(0, 0, 0)
  const up = vec3.fromValues(0, 1, 0)
  mat4.lookAt(v, eye, look, up)
  const m = mat4.create()
  const guiInfo = {
    type: 0
  }
  const gui = new GUI()
  const guiType = gui
    .add(guiInfo, 'type', {
      'Phong光照模型': 0,
      'Phong-Blinn光照模型': 1,
      '卡通渲染（Cel-Shading）': 2,
      '卡通渲染+描边': 3,
      '边缘光': 4,
      'tone based shading': 5
    })
    .name('着色类型')
  const shaderType = new WeShaderData({
    type: '1f',
    name: 'u_ShaderType',
    value: guiInfo.type,
    isUniform: true
  })
  const model = new WeShaderData({
    type: 'm4fv',
    name: 'u_Model',
    value: m,
    isUniform: true
  })
  const view = new WeShaderData({
    type: 'm4fv',
    name: 'u_View',
    value: v,
    isUniform: true
  })
  const projection = new WeShaderData({
    type: 'm4fv',
    name: 'u_Projection',
    value: p,
    isUniform: true
  })
  const lightPos = new WeShaderData({
    type: '3fv',
    name: 'u_LightPos',
    value: [-100, 500, 500],
    isUniform: true
  })
  const light = new WeShaderData({
    type: '4fv',
    name: 'u_Light',
    value: Tool.decodeColor('#FFFFFF'),
    isUniform: true
  })
  const eyePos = new WeShaderData({
    type: '3fv',
    name: 'u_Eye',
    value: eye,
    isUniform: true
  })
  let angle = 0
  downloadMeshes({
    apple: `${baseUrl}/assets/model/apple.obj` // 加载模型文件
  }, meshs => {
    const apple = meshs.apple
    const indices = apple.indicesPerMaterial.flat() // 顶点索引数组
    console.log(apple)
    const posBuffer = new WeShaderBuffer({
      type: 'vertex',
      value: apple.vertices // 顶点
    })
    const pos = new WeShaderData({
      type: '3fv',
      name: 'a_Pos',
      value: []
    })
    const normalBuffer = new WeShaderBuffer({
      type: 'vertex',
      value: apple.vertexNormals // 顶点法向量
    })
    const normal = new WeShaderData({
      type: '3fv',
      name: 'a_Normal',
      value: []
    })
    const indexBuffer = new WeShaderBuffer({
      type: 'index',
      value: indices // 顶点索引
    })
    pos.bindVBO(posBuffer, {
      unitType: 'float',
      unitNum: 3,
      size: 3
    })
    pos.bindProgram(program)
    pos.useVBO()
    normal.bindVBO(normalBuffer, {
      unitType: 'float',
      unitNum: 3,
      size: 3
    })
    shaderType.bindProgram(program)
    normal.bindProgram(program)
    normal.useVBO()
    model.bindProgram(program)
    view.bindProgram(program)
    projection.bindProgram(program)
    light.bindProgram(program)
    lightPos.bindProgram(program)
    eyePos.bindProgram(program)
    indexBuffer.useBuffer()
    ctx.enable(ctx.DEPTH_TEST)
    ctx.enable(ctx.CULL_FACE)
    project.background(Tool.decodeColor('#EEEEEE') as [number, number, number, number])
    const draw = () => {
      mat4.fromRotation(m, Tool.toRadian(angle), vec3.fromValues(0, 1, 0))
      model.update(m)
      project.clear()
      ctx.drawElements(ctx.TRIANGLES, indices.length, ctx.UNSIGNED_SHORT, 0)
      angle = (angle + 1) % 360
    }
    guiType.onFinishChange(() => {
      shaderType.update(guiInfo.type)
      draw()
    })
    draw()
    project.loop(draw)
  }, {})
})()
